import { useSelector } from 'react-redux';

import { getCommuterBenefitsEnabled } from 'selectors/session';

import { BENEFIT_TYPE_MAP, BENEFIT_TYPE_OPTIONS } from './constants';

export const useAdditionalBenefits = () => {
  const commuterBenefitsEnabled = useSelector(getCommuterBenefitsEnabled);

  if (commuterBenefitsEnabled) {
    return {
      benefitTypeOptions: [
        ...BENEFIT_TYPE_OPTIONS,
        { value: 'transit', label: 'Transit' },
        { value: 'parking', label: 'Parking' },
      ],
      benefitTypeMap: {
        ...BENEFIT_TYPE_MAP,
        ...{
          transit: {
            name: 'transit',
            description:
              'team.employee_profile.tax_deductions.description.transit',
          },
          parking: {
            name: 'parking',
            description:
              'team.employee_profile.tax_deductions.description.parking',
          },
        },
      },
    };
  }
  return {
    benefitTypeOptions: BENEFIT_TYPE_OPTIONS,
    benefitTypeMap: BENEFIT_TYPE_MAP,
  };
};
